import ContextEvent from "../../../../../shared/src/ranj/app/core/ContextEvent";
import NavigateEvent from "../../../../../shared/src/ranj/app/navigation/NavigateEvent";
import AnimationOptions from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AnimationDuration from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationDuration";
import AnimationFactory from "../../../../../shared/lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import SoundType from "../../../../../shared/src/ranj/app/sound/SoundType";
import Button from "../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import StartupEvent from "../../../../../shared/src/ranj/app/startup/StartupEvent";
import AbstractScreenMediator from "../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";


export default class SplashLoadScreenMediator extends AbstractScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config, screenNavigator) {
        super(target, dispatcher, languagePack, layoutManager);
        console.info("SplashLoadScreenMediator constructor");
        this._soundManager = soundManager;
        this.dispatcher = dispatcher;
        this._startup = startup;
        this._config = config;
        this._screenNavigator = screenNavigator;

        this.setProgress(0);

        this._handlePreloadCompleteBound = this.handlePreloadComplete.bind(this);
        this._handleLoadProgressBound = this.handleLoadProgress.bind(this);
    };

    initialize() {
        super.initialize();
        this._startup.addEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.addEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);

        this._onStartButtonWasClicked = this.onStartButtonWasClicked.bind(this);
        var buttonStartSkin = this._target.startButton;

        this._buttonStartGame = this.createButton(buttonStartSkin, this._onStartButtonWasClicked, this.getText("start.button"));
        this._buttonStartGame.skin.visible = false;

        this._target.titleTextfield.text = this.getText("start.title");
        this._target.bodyTextfield.text = this.getText("start.body");
        this._target.loadingTextField.text = this.getText("start.loading");

        this._showVersion();

        if (this._target.bg) {
            //this.stretchBackground(this._target.bg);
        }
        this.anchorObject(this._target.startButton, Anchor.B);
        this.anchorObject(this._target.versionTextField, Anchor.B);
        this.anchorObject(this._target.loadingBar, Anchor.B);
        this.anchorObject(this._target.loadingTextField, Anchor.B);
        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
    };

    destroy() {
        super.destroy();
        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
    };

    _showVersion() {
        if (this._target.versionTextField) {
            var version = this._config.getValue(Config.VERSION);
            var commitHash = this._config.getValue(Config.COMMIT_HASH);

            var str = `${version} (${commitHash})`;
            this._target.versionTextField.text = str;

            this.anchorObject(this._target.versionTextField, Anchor.B);
        }
    };

    handleLoadProgress(event) {
        var progress = event.data.progress;
        this.setProgress(progress);
    };

    setProgress(progress) {
        var t = this._target.loadingBar.duration;
        var percentage = Math.round(t * progress);
        this._target.loadingBar.gotoAndStop(Math.min(t - 1, percentage));
    };


    onStartButtonWasClicked(event) {
        //this.playSound(SoundType.SOUND_CLICK);
        // this._soundManager.initializeStreamChannels("./assets/sounds/silent.mp3");
        this._buttonStartGame.setEnabled(false);
        this.callDelayed(this.start.bind(this), 30);
    };

    start() {
        var contextEvent = new ContextEvent(ContextEvent.START_GAME);
        this.dispatcher.dispatch(contextEvent.type, { data: contextEvent });
    }


    handlePreloadComplete(event) {
        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
        this._target.loadingBar.visible = this._target.loadingTextField.visible = false;
        this._buttonStartGame.skin.visible = true;
        //
        if (getURLParameter("autostart") == "1") {
            setTimeout(function() { this.onStartButtonWasClicked(); }.bind(this), 15);
        }
    };

}